import { useTranslation } from "react-i18next"

import { toaster } from "@/components/ui/toaster"

const useCustomToast = () => {
  const { t } = useTranslation("common")

  const showToast = (
    title: string,
    description: string,
    type: "success" | "error",
  ) => {
    toaster.create({
      title,
      description,
      type,
      meta: { closable: true },
    })
  }

  const showErrorToast = (description: string) => {
    showToast(t("toast.errorTitle"), description, "error")
  }

  const showSuccessToast = (description: string) => {
    showToast(t("toast.successTitle"), description, "success")
  }

  return { showToast, showSuccessToast, showErrorToast }
}

export default useCustomToast
